
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EmailLoginForm } from "./EmailLoginForm";
import { PhoneLoginForm } from "./PhoneLoginForm";

type LoginTabsProps = {
  activeTab: string;
  onTabChange: (tab: string) => void;
  isLoading: boolean;
  onSubmit: (email: string, password: string) => Promise<void>;
  onError: (error: string) => void;
}

export const LoginTabs: React.FC<LoginTabsProps> = ({
  activeTab,
  onTabChange,
  isLoading,
  onSubmit,
  onError
}) => {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
      <TabsList className="grid grid-cols-2 w-full mb-6">
        <TabsTrigger value="email">Email</TabsTrigger>
        <TabsTrigger value="phone">Телефон</TabsTrigger>
      </TabsList>
      
      <TabsContent value="email">
        <EmailLoginForm 
          isLoading={isLoading}
          onSubmit={onSubmit}
          onError={onError}
        />
      </TabsContent>
      
      <TabsContent value="phone">
        <PhoneLoginForm />
      </TabsContent>
    </Tabs>
  );
};
